import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, NgModule, OnInit, Output } from '@angular/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

@Component({
    selector: 'app-take-off-drawing-color-picker',
    templateUrl: './take-off-drawing-color-picker.component.html',
    styleUrls: ['./take-off-drawing-color-picker.component.scss'],
    standalone: false,
})
export class TakeOffDrawingColorPickerComponent implements OnInit {
    // @ts-ignore TS2564
    @Input() selectedColor: string;
    @Output() colorChanges = new EventEmitter<string>();

    public readonly drawingColors = [
        '#FF0000',
        '#FFA500',
        '#FFFF00',
        '#9ACD32',
        '#90EE90',
        '#008000',
        '#7FFFD4',
        '#00FFFF',
        '#ADD8E6',
        '#0000FF',
        '#00008B',
        '#9400D3',
        '#EE82EE',
        '#800080',
        '#FFC0CB',
    ];

    constructor() {}

    ngOnInit(): void {}

    public onColorChanged(color: string) {
        this.colorChanges.emit(color);
    }
}

@NgModule({
    declarations: [TakeOffDrawingColorPickerComponent],
    imports: [CommonModule, TooltipModule, BsDropdownModule],
    exports: [TakeOffDrawingColorPickerComponent],
})
export class TakeOffDrawingColorPickerModule {}
